import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-radius: 10px;
  padding-left: 22px;
  padding-right: 22px;
  border: 1px solid transparent;
  font-size: 1rem;
  i {
    margin-left: 10px;
  }
`
const Flat = styled(Container)`
    background-color: transparent;
    border-color: #FFF;
    
    color: #FFF;

  ${({ primary }) => primary && `
    color: var(--cPrimaryLight);
    border-color: var(--cPrimaryLight);
  `}

    &:hover {
      background-color: var(--cThird);
      border-color: var(--cThird);
      color: var(--cPrimaryDark);
    }
`
const Solid =  styled(Container)`
    background-color: var(--cPrimaryLight);
    color: #FFF;
    &:hover {
      color: var(--cPrimaryDark);
      background-color: var(--cThird);
    }
`
const Button = ({ children, flat, link, target, primary }) => {
    if(flat) {
      return <Flat primary={primary} href={link} target={target}>{children}</Flat>
    } else {
      return <Solid href={link} target={target}>{children}</Solid>
    }
}


Button.propTypes = {
  flat: PropTypes.bool,
  primary: PropTypes.bool,
  link: PropTypes.string,
  target: PropTypes.string
}
Button.defaultProps = {
  flat: false,
  primary: false,
  link: '',
  target: ''
}
export default Button
